import CustomerEditActivity from "./CustomerEditActivity";
import CustomerEditActivityPopup from "./CustomerEditActivityPopup";

export default CustomerEditActivity;

export { CustomerEditActivityPopup };
